import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import ErrorBoundary from '../../../../shared/error-boundary';
import Header from './header';
import Title from './title';
import Body from './body';
import StandfirstSummary from './standfirst-summary';
import CTA from './cta';
import Disclaimer from './disclaimer';
import MicroProfile from '../../../micro-profiles/micro-profile';
import { SectionSeparator } from './shared/styles';
import useEditorStore from '../state-hook';

export default function EditorContent({ standfirstSummary, showCTA }) {
  const titleRef = React.useRef();
  const bodyRef = React.useRef();
  const wire = useEditorStore(state => state.wire);

  React.useEffect(() => {
    titleRef.current && bodyRef.current
      && titleRef.current.setNextFocusOnEnter(_.first(bodyRef.current.editor.elements));
  }, []);

  const profile = _.get(wire, 'profile', {});
  const id = _.get(wire, 'id');

  return (
    <ErrorBoundary>
      <article className="wire full-wire">
        <form className="wire-editor --user-facing">
          <header>
            <Header
              categoryName={_.get(wire, 'category.name')}
              seriesTitle={_.get(wire, 'series.title')}
              isSponsored={_.get(wire, 'isSponsored')}
            />
            <Title wireId={id} value={_.get(wire, 'title')} ref={titleRef} />
            <div className="wire-avatar-byline-wrapper hide-fully--desktop">
              <img
                className="avatar avatar--large float-left margin-med-right"
                src={profile.profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png')}
                alt="Avatar"
              />
              <div className="wire-byline">
                <a className="wire-author" href={`/contributors/${profile.slug}`}>
                  {profile.name}
                </a>
                <div className="wire-organisation">{profile.organization}</div>
              </div>
            </div>
            <div className="clearfix" />
          </header>
          {standfirstSummary
          && (
            <StandfirstSummary wireId={id} value={_.get(wire, 'summary') || ''} />
          )}
          <div className="wire-body-row">
            <div className="avatar-container hide-fully--mobile hide-fully--tablet">
              <Sticky top={183}>
                {!!profile.name && (
                  <MicroProfile
                    profile={{ ...profile, areasOfExpertise: [] }}
                    wire={wire}
                    investorTypes={[]}
                    isOfCurrentUser
                    isProfileFollowedByCurrentUser={false}
                    isOnWireSide
                  />
                )}
              </Sticky>
            </div>
            <div className="wire-body-container">
              <Body
                wireId={id}
                value={_.get(wire, 'body')}
                disclaimer={_.get(wire, 'disclaimer')}
                ref={bodyRef}
              />
              {showCTA && <SectionSeparator length={180} />}
              {showCTA && <CTA />}
              <SectionSeparator length={180} />
              <Disclaimer />
            </div>
          </div>
        </form>
      </article>
    </ErrorBoundary>
  );
}

EditorContent.propTypes = {
  standfirstSummary: PropTypes.bool.isRequired,
  showCTA: PropTypes.bool.isRequired,
};
